import React from "react";

interface WishlistProps {
    enable: boolean;
    onChange?: (status: boolean) => void;
}

export const Wishlist: React.FC<WishlistProps> = ({ onChange, enable }) => {
    const change = () => {
        if(onChange) onChange(!enable);
    }
    
    return (
        <div className="cursor-pointer" onClick={ () => change() }>
            <div className="hidden md:block bg-white p-3 rounded-2xl ">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M16.0002 8.625C16.9188 7.56712 18.508 6 20.928 6C25.1613 6 28 9.91125 28 13.5534C28 21.1673 18.3707 27 16 27C13.6293 27 4 21.1673 4 13.5534C4 9.91125 6.83867 6 11.072 6C13.492 6 15.0815 7.56712 16.0002 8.625Z"
                          fill={ enable ? `#E73140` : `#fff` } stroke={ enable ? `#E73140` : `#949494` }
                          strokeWidth="1.7" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            </div>
            <div className="md:hidden" onClick={ () => change() }>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M9.99978 5.10433C10.6058 4.39068 11.6543 3.3335 13.2508 3.3335C16.0436 3.3335 17.9163 5.97204 17.9163 8.42907C17.9163 13.5654 11.5637 17.5002 9.99967 17.5002C8.43569 17.5002 2.08301 13.5654 2.08301 8.42907C2.08301 5.97204 3.95574 3.3335 6.74856 3.3335C8.34509 3.3335 9.39372 4.39068 9.99978 5.10433Z"
                          fill={ enable ? `#E73140` : `none` } stroke={ enable ? `#E73140` : `#949494` } strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </div>
    )
}